<template>
    <LenderSelectionList />
</template>

<script>
import LenderSelectionList from '@/components/Application/LenderSelectionList.vue'
export default {
  components: {
    LenderSelectionList
  }
}
</script>

<style lang="scss" scoped>
.buttons {
  display: flex;
  justify-content: flex-end;
}
</style>



// WEBPACK FOOTER //
// src/components/PageLenderSelectionWizard.vue